'use strict';

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var serviceTypes = require('./serviceTypes');

module.exports = (_module$exports = {}, _defineProperty(_module$exports, serviceTypes.MEDIASHUTTLE, 'mediaShuttle'), _defineProperty(_module$exports, serviceTypes.FLIGHT_GATEWAY, 'flightGateway'), _defineProperty(_module$exports, serviceTypes.JET, 'jet'), _defineProperty(_module$exports, serviceTypes.MANAGER_AND_AGENTS_SAAS, 'flightDeck'), _defineProperty(_module$exports, serviceTypes.MEDIA_ENGINE, 'mediaEngine'), _module$exports);